module.exports = __webpack_public_path__ + "static/img/组 2894.73c549c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2894.png
// module id = hZj0
// module chunks = 0